import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import './PhoneNumberInput.css';

import logo from '../logo.svg';
import { auth } from '../firebase';
import { RecaptchaVerifier } from 'firebase/auth';

import Alert from './Alert';

const SendOTP = ({ onSendOTP }) => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {
            'size': 'invisible',
            'callback': (response) => {
                // reCAPTCHA solved, allow signInWithPhoneNumber.
            }
        }, auth);
    }, []);

    const onSignup = () => {
        if (!phoneNumber) {
            setError('Silakan masukkan nomor telepon Anda.');
            return;
        }
        setError(null);
        setLoading(true);
        onSendOTP(phoneNumber)
            .then((confirmationResult) => {
                window.confirmationResult = confirmationResult;
                navigate('/verify-otp', { state: { phoneNumber: phoneNumber } });
            })
            .catch((error) => {
                console.error("Error sending OTP:", error);
                if (error.code === 'auth/timeout') {
                    setError('Waktu permintaan habis, silakan coba lagi.');
                } else {
                    setError('Terjadi kesalahan, silakan coba lagi: ' + error.message);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            onSignup();
        }
    }

    return (
        <div className="flex items-center justify-center h-screen bg-brand-dark">
            <div id="recaptcha-container"></div>
            <div className="w-full max-w-md p-8 space-y-6 bg-brand-gray rounded-lg shadow-md">
                <Link to="/">
                    <img src={logo} className="w-20 h-20 mx-auto" alt="logo" />
                </Link>
                <h2 className="text-2xl font-bold text-center text-white">Masuk</h2>
                <p className="text-center text-gray-400">Silakan masukkan nomor telepon Anda untuk masuk.</p>
                {error && <Alert message={error} type="error" />}
                <div className="space-y-4">
                    <div>
                        <PhoneInput
                            autoFocus
                            defaultCountry="ID"
                            placeholder="81234567890"
                            value={phoneNumber}
                            onChange={(value) => {
                                setPhoneNumber(value);
                                if (error) {
                                    setError(null);
                                }
                            }}
                            onKeyDown={handleKeyDown}
                            className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-lime"
                        />
                    </div>
                    <button 
                        onClick={onSignup} 
                        disabled={loading}
                        className="w-full px-4 py-2 font-bold text-brand-dark bg-brand-lime rounded-md hover:bg-lime-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-lime disabled:opacity-50"
                    >
                        {loading ? 'Mengirim...' : 'Kirim OTP'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SendOTP;